import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import { setCredentials } from '../slices/authSlice';
import { useVerifyEmailMutation } from '../slices/usersApiSlice';

const VerifyEmailScreen = () => {

    const dispatch = useDispatch();
    const { userInfo } = useSelector((state) => state.auth);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    const [verifyEmail, { data, error, isLoading, isSuccess }] = useVerifyEmailMutation();

    const [message, setMessage] = useState('Email verification in progress...');

    // A changed email: keep this device's signed-in details up to date
    useEffect(() => {
        if (data?.email && userInfo?._id === data._id && userInfo.email !== data.email) {
            dispatch(setCredentials({ ...userInfo, email: data.email, pendingEmail: undefined }));
        }
    }, [data, userInfo, dispatch]);

    useEffect(() => {
        if (token) {
            verifyEmail({ token });
        }
    }, [token, verifyEmail]);

    useEffect(() => {

        if (isLoading) {
            setMessage('Email verification in progress...');
        } else if (isSuccess) {
            setMessage(data?.email
                ? `Thank you. Your account email is now ${data.email}.`
                : 'Thank you for confirming your email. Please select the button below to sign in.');
        } else if (error) {
            setMessage(error?.data?.message || error.error);
            toast.error(error?.data?.message || error.error);
        }
    }, [isLoading, isSuccess, error, data]);

    return (
        <div>
            {isLoading ? (
                <Loader />
            ) : (
                <div>
                    <p className="mt-2" >  {message}</p>
                    {isSuccess && (
                        <Link to="/login" className="btn btn-primary my-2 blue-outline">
                            Sign in
                        </Link>
                    )}
                </div>
            )}
        </div>
    );
};

export default VerifyEmailScreen;
